import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import GeneralUtilsContextProvider from "./utils/GeneralUtilsContext";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <BrowserRouter>
      <GeneralUtilsContextProvider>
        <App />
      </GeneralUtilsContextProvider>
    </BrowserRouter>
);
